import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { SabiasQueNY } from "./nyHelpers";

const imageStyle = {
	width: 70,
	height: 70,
	minWidth: 70,
	objectFit: "cover",
	borderRadius: 10,
};

// Template83: Día 4 Otros rincones Central Park + museos (Page14). Contenido desde page.
const Template83 = ({
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const parseSabiasQueItem = (html) => {
		if (!html) return null;
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");
		const p = doc.querySelector("p");
		if (!p) return null;
		const text = (p.textContent ?? p.innerText ?? "").trim();
		if (!text) return null;
		const emojiMatch = text.match(/^([^\s]+)\s+(.*)/s);
		if (emojiMatch)
			return { icono: emojiMatch[1], texto: emojiMatch[2].trim() };
		return null;
	};

	const title = page?.texts?.[0]?.content;
	const titleShort = page?.texts?.[1]?.content;
	const sectionOtros = page?.texts?.[2]?.content;
	const pondTitle = page?.texts?.[3]?.content;
	const pondBody = page?.texts?.[4]?.content;
	const boathouseTitle = page?.texts?.[5]?.content;
	const boathouseBody = page?.texts?.[6]?.content;
	const umpireTitle = page?.texts?.[7]?.content;
	const umpireBody = page?.texts?.[8]?.content;
	const mallTitle = page?.texts?.[9]?.content;
	const mallBody = page?.texts?.[10]?.content;
	const sabiasQueSkate = parseSabiasQueItem(page?.texts?.[11]?.content);
	const yellowShort = page?.texts?.[12]?.content;
	const yellowLong = page?.texts?.[13]?.content;
	const masTiempo = page?.texts?.[14]?.content;
	const museosH3 = page?.texts?.[15]?.content;
	const historiaTitle = page?.texts?.[16]?.content;
	const historiaBody = page?.texts?.[17]?.content;
	const metTitle = page?.texts?.[18]?.content;
	const metBody = page?.texts?.[19]?.content;
	const sabiasQueDino = parseSabiasQueItem(page?.texts?.[20]?.content);
	const sabiasQueMet = parseSabiasQueItem(page?.texts?.[21]?.content);
	const topBoxHtml = page?.texts?.[22]?.content;

	const displayTitle = isSmallScreen && titleShort ? titleShort : title;
	const yellowBarcas = isSmallScreen && yellowShort ? yellowShort : yellowLong;

	const bridgeSrc = getImageSrc("bridge");
	const boathouseSrc = getImageSrc("boathouse");
	const umpireSrc = getImageSrc("umpire");
	const mallSrc = getImageSrc("mall");
	const boatSrc = getImageSrc("boat");
	const historiaSrc = getImageSrc("historia");
	const metSrc = getImageSrc("met");
	const logoSrc = getCanvasImageUrl("logo");

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				backgroundColor: "#f7f7f7",
				position: "relative",
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				"& p": { marginTop: "0px !important", marginBottom: "0px !important" },
				"& a": {
					color: "#007a8d",
					fontWeight: 700,
					textDecoration: "underline",
				},
			}}
		>
			<div
				data-block-id="header"
				style={{
					backgroundColor: headerBackgroundColor || "#59c3d8",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontFamily: fontFamily || '"Poppins", sans-serif',
					fontSize: "14px",
					fontWeight: 700,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{displayTitle}
				{logoSrc && (
					<img
						src={logoSrc}
						alt="logo"
						style={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</div>

			{sectionOtros && (
				<h3
					style={{
						fontFamily: '"Poppins", sans-serif',
						fontSize: 14,
						fontWeight: 700,
						textTransform: "uppercase",
						padding: "12px 12px 0",
						margin: 0,
						marginBottom: 12,
					}}
				>
					{sectionOtros}
				</h3>
			)}
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: 8,
					padding: "0 12px",
					position: "relative",
				}}
			>
				{sabiasQueSkate && (
					<div
						style={{
							position: "absolute",
							top: 60,
							left: isSmallScreen ? "60%" : "42%",
						}}
					>
						<SabiasQueNY
							icono={sabiasQueSkate.icono}
							texto={sabiasQueSkate.texto}
						/>
					</div>
				)}
				{(pondTitle || pondBody || bridgeSrc) && (
					<div data-block-id="text-1" style={{ display: "flex", gap: 16 }}>
						{bridgeSrc && (
							<img src={bridgeSrc} style={imageStyle} alt="The Pond" />
						)}
						<div>
							{pondTitle && (
								<h4
									style={{
										fontFamily: '"Poppins", sans-serif',
										fontSize: 13,
										fontWeight: 700,
										margin: 0,
									}}
								>
									{pondTitle}
								</h4>
							)}
							{pondBody && (
								<p
									style={{
										fontFamily: '"Poppins", sans-serif',
										fontSize: 13,
										color: "#444",
										margin: 0,
									}}
								>
									{pondBody}
								</p>
							)}
						</div>
					</div>
				)}
				{(boathouseTitle || boathouseBody || boathouseSrc) && (
					<div data-block-id="text-2" style={{ display: "flex", gap: 16 }}>
						{boathouseSrc && (
							<img src={boathouseSrc} style={imageStyle} alt="Loeb Boathouse" />
						)}
						<div>
							{boathouseTitle && (
								<h4
									style={{
										fontFamily: '"Poppins", sans-serif',
										fontSize: 13,
										fontWeight: 700,
										margin: 0,
									}}
								>
									{boathouseTitle}
								</h4>
							)}
							{boathouseBody && (
								<p
									style={{
										fontFamily: '"Poppins", sans-serif',
										fontSize: 13,
										color: "#444",
										margin: 0,
									}}
								>
									{boathouseBody}
								</p>
							)}
						</div>
					</div>
				)}
				{(umpireTitle || umpireBody || umpireSrc) && (
					<div data-block-id="text-3" style={{ display: "flex", gap: 16 }}>
						{umpireSrc && (
							<img src={umpireSrc} style={imageStyle} alt="Umpire Rock" />
						)}
						<div>
							{umpireTitle && (
								<h4
									style={{
										fontFamily: '"Poppins", sans-serif',
										fontSize: 13,
										fontWeight: 700,
										margin: 0,
									}}
								>
									{umpireTitle}
								</h4>
							)}
							{umpireBody && (
								<p
									style={{
										fontFamily: '"Poppins", sans-serif',
										fontSize: 13,
										color: "#444",
										margin: 0,
									}}
								>
									{umpireBody}
								</p>
							)}
						</div>
					</div>
				)}
				{(mallTitle || mallBody || mallSrc) && (
					<div data-block-id="text-4" style={{ display: "flex", gap: 16 }}>
						{mallSrc && <img src={mallSrc} style={imageStyle} alt="The Mall" />}
						<div>
							{mallTitle && (
								<h4
									style={{
										fontFamily: '"Poppins", sans-serif',
										fontSize: 13,
										fontWeight: 700,
										margin: 0,
									}}
								>
									{mallTitle}
								</h4>
							)}
							{mallBody && (
								<p
									style={{
										fontFamily: '"Poppins", sans-serif',
										fontSize: 13,
										color: "#444",
										margin: 0,
									}}
								>
									{mallBody}
								</p>
							)}
						</div>
					</div>
				)}
				{boatSrc && (
					<img
						src={boatSrc}
						alt="Boat"
						style={{ width: 100, position: "absolute", bottom: -44, right: 0 }}
					/>
				)}
				{yellowBarcas && (
					<div
						style={{
							position: "absolute",
							bottom: 31,
							right: 10,
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "16px 16px 0px 16px",
							padding: "10px 12px",
							fontSize: 11,
							fontFamily: '"Poppins", sans-serif',
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 125,
						}}
					>
						{yellowBarcas}
					</div>
				)}
				{masTiempo && (
					<div data-block-id="text-5" style={{ width: isSmallScreen ? "60%" : "80%" }}>
						<p
							style={{
								fontFamily: '"Poppins", sans-serif',
								fontSize: 13,
								color: "#444",
								paddingTop: 8,
								margin: 0,
							}}
						>
							{masTiempo.includes("\n") ? (
								<>
									<strong>{masTiempo.split("\n")[0]}</strong>
									<br />
									{masTiempo.split("\n").slice(1).join(" ")}
								</>
							) : (
								masTiempo
							)}
						</p>
					</div>
				)}
			</div>

			{museosH3 && (
				<h3
					style={{
						fontFamily: '"Poppins", sans-serif',
						fontSize: 14,
						fontWeight: 700,
						textTransform: "uppercase",
						padding: "10px 12px 0",
						marginBottom: 8,
						marginTop: isSmallScreen ? 40 : 8,
					}}
				>
					{museosH3}
				</h3>
			)}
			<div
				data-block-id="text-6"
				style={{
					display: "flex",
					justifyContent: "space-between",
					gap: 12,
					padding: "0 12px",
					position: "relative",
				}}
			>
				{(historiaTitle || historiaBody || historiaSrc) && (
					<div style={{ width: "50%" }}>
						{historiaSrc && (
							<img
								src={historiaSrc}
								style={{
									width: "100%",
									height: 70,
									objectFit: "cover",
									borderRadius: 12,
									marginBottom: 6,
								}}
								alt="Museo Historia Natural"
							/>
						)}
						{historiaTitle && (
							<h4
								style={{
									fontFamily: '"Poppins", sans-serif',
									fontSize: 13,
									fontWeight: 700,
									margin: 0,
									marginBottom: 4,
								}}
							>
								{historiaTitle}
							</h4>
						)}
						{historiaBody && (
							<p
								style={{
									fontFamily: '"Poppins", sans-serif',
									fontSize: 12,
									color: "#444",
									margin: 0,
								}}
								dangerouslySetInnerHTML={{ __html: historiaBody }}
							/>
						)}
					</div>
				)}
				{(metTitle || metBody || metSrc) && (
					<div style={{ width: "50%" }}>
						{metSrc && (
							<img
								src={metSrc}
								style={{
									width: "100%",
									height: 70,
									objectFit: "cover",
									borderRadius: 12,
									marginBottom: 6,
								}}
								alt="MET"
							/>
						)}
						{metTitle && (
							<h4
								style={{
									fontFamily: '"Poppins", sans-serif',
									fontSize: 13,
									fontWeight: 700,
									margin: 0,
									marginBottom: 4,
								}}
							>
								{metTitle}
							</h4>
						)}
						{metBody && (
							<p
								style={{
									fontFamily: '"Poppins", sans-serif',
									fontSize: 12,
									color: "#444",
									margin: 0,
								}}
								dangerouslySetInnerHTML={{ __html: metBody }}
							/>
						)}
					</div>
				)}
				{sabiasQueDino && (
					<div
						style={{
							position: "absolute",
							top: isSmallScreen ? 10 : 50,
							left: "42%",
						}}
					>
						<SabiasQueNY
							icono={sabiasQueDino.icono}
							texto={sabiasQueDino.texto}
						/>
					</div>
				)}
				{sabiasQueMet && (
					<div
						style={{
							position: "absolute",
							top: 0,
							right: isSmallScreen ? "33%" : "22%",
						}}
					>
						<SabiasQueNY
							icono={sabiasQueMet.icono}
							texto={sabiasQueMet.texto}
						/>
					</div>
				)}
			</div>

			{topBoxHtml && (
				<div data-block-id="text-7" style={{ padding: "0 12px" }}>
					<div
						style={{
							backgroundColor: "#e0f7fa",
							border: "3px solid #59c3d8",
							borderRadius: 12,
							padding: "12px 14px",
							fontSize: 12,
							fontFamily: '"Poppins", sans-serif',
							color: "#333",
							marginTop: 12,
							marginBottom: 12,
						}}
					>
						<p
							style={{
								fontFamily: '"Poppins", sans-serif',
								fontSize: 13,
								color: "#444",
								margin: 0,
							}}
							dangerouslySetInnerHTML={{ __html: topBoxHtml }}
						/>
					</div>
				</div>
			)}
		</Box>
	);
};

export default Template83;
